import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DatePicker, Form, Input, Select, Checkbox, Modal, Upload, Button } from 'antd';
import locale from 'antd/es/date-picker/locale/ru_RU';
import EmojiTextArea from '../../../common/EmojiTextArea';
import Autocomplete from '../../components/Autocomplete';
import uuid from 'react-uuid';
import { Field, GET, GETWITH, JSXMap, Model, QueryDetail, QueryOrder, QueryParam, errorCatch, uncapitalize, ycStorage, formItemRules } from 'fennec-ui';
import { ycBucket } from '../../../common/Tool';
import emoji from "@jukben/emoji-search";
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { ExclamationCircleOutlined, UploadOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import YImage from '../../../common/YImage';
import { name } from 'dayjs/locale/ru';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const { Option } = Select;

const Item = React.forwardRef((props, ref) => {
    const { key, icon, name, selected, style, onMouseEnter, onClick } = props;
    return (
        <div ref={ref} onMouseEnter={onMouseEnter} onClick={onClick} key={key} style={{ width: "100%", display: "flex", justifyContent: "space-between", whiteSpace: "nowrap", textOverflow: "ellipsis", borderRadius: "2px", backgroundColor: (selected) ? "#dcefff" : "transparent", ...style }}>
            <div style={{
                flex: "0 0 15px", marginLeft: "1px",
                marginRight: "3px",
                textAlign: "center"
            }}>{(icon) ? icon : <i className="fa fa-at" style={{ fontSize: "12px" }}></i>}</div>
            <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>{`${name}`}</div>
        </div>
    )
});

const MultilineItem = React.forwardRef((props, ref) => {
    const { key, icon, name, description, image, selected, style, onMouseEnter, onClick } = props;
    return (
        <div
            ref={ref}
            onMouseEnter={onMouseEnter}
            onClick={onClick}
            key={key}
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                borderRadius: "2px",
                backgroundColor: (selected) ? "#dcefff" : "transparent",
                ...style
            }}>
            <div style={{
                flex: "0 0 15px", marginLeft: "1px",
                marginRight: "3px",
                textAlign: "center"
            }}>
                {(icon) ? icon : <i className="fa fa-at" style={{ fontSize: "12px" }}></i>}
            </div>
            <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>
                <div style={{ display: "flex", overflow: "hidden", textOverflow: "ellipsis" }}>
                    <div style={{ flex: "0 0 30px", padding: "4px 0px" }}>
                        {image && <img src={image} style={{ width: "30px", marginRight: "5px", borderRadius: "3px" }} />}
                    </div>
                    <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>
                        <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{`${name}`}</div>
                        {description && <div style={{ fontSize: "10px", color: "#5e5e5e", overflow: "hidden", textOverflow: "ellipsis" }}>{`${description}`}</div>}
                    </div>
                </div>
            </div>
        </div>
    )
});

export const temaName = (id) => {
    switch (id) {
        case 2:
            return "myresult"
        case 3:
            return "rezultati-final"
        case 4:
            return "promokodi-meropriyatiya"
        default:
            return "common"
    }
}

function UploadFiles({ auth, item, value, onChange, changed, fileErrors, object }) {
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);

    useEffect(() => {
        triggerChange(files?.map(e => e.originFileObj));
    }, [files]);
    const triggerChange = (changedValue) => {
        if (onChange) {
            onChange([
                ...changedValue,
            ]);
        }
    };
    const onUploadChange = ({ fileList: newFileList }) => {
        setFiles(newFileList);
    };
    const uploadingProps = {
        maxCount: 10,
        name: 'files',
        multiple: true,
        showUploadList: item.showUploadList,
        accept: item.accept,
        onRemove: file => {
            const index = files.indexOf(file);
            const newFiles = files.slice();
            newFiles.splice(index, 1);
            setFiles(newFiles);
        },
        // beforeUpload: (file, fileList) => {
        //     setFiles(o => [...o, file]);
        //     return false;
        // },
        fileList: files,
        onChange: onUploadChange,
        itemRender: (originNode, file) => {
            let xx = fileErrors?.find(x => file.name == x.FileHeader.Filename)
            return (
                <div>
                    {originNode}
                    {((file.status == "error") || xx) && <div style={{ color: "red" }}>{(xx) ? xx.Message : undefined}</div>}
                </div>
            )
        }
    };
    return (<Upload
        {...uploadingProps}
    >
        {!item.trigger && <Button icon={<UploadOutlined />}>Загрузить файлы</Button>}
        {item?.trigger && item?.trigger()}
    </Upload>)
}

export default function RassilkiForm(props) {
    const { auth, form, options, object, funcStat, contextFilters, submit } = props;
    useEffect(() => {
        form.resetFields();
    }, []);

    const SearchItem = (item) => {
        const fallback = "data:image/png;base64,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"
        const getAlias = (item) => (item.alias) ? item.alias : item.objId;
        if (item.festivalID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.festival?.nazvanie,
                detail: `![](${(item?.festival?.afishaMin) ? encodeURI(ycStorage(auth) + ycBucket(auth) + "/" + item?.festival?.afishaMin) : fallback})`,
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.festival?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Фестиваль, ${dayjs(item?.festival?.dataNachala).tz("Europe/Moscow").format('DD.MM.YYYY')}, ${item?.festival?.gorodProvedeniya?.name}`,
                image: (item?.festival?.afishaMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.festival?.afishaMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.meropriyatieID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.meropriyatie?.nazvanieMeropriyatiya,
                detail: `![](${(_.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin) ? encodeURI(ycStorage(auth) + ycBucket(auth) + "/" + _.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin) : fallback})`,
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.meropriyatie?.nazvanieMeropriyatiya + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Мероприятие, ${dayjs(item?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}, ${item?.meropriyatie?.mestoProvedeniya?.name}`,
                image: (_.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin) ? ycStorage(auth) + ycBucket(auth) + "/" + _.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.seriyaID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.seriya?.nazvanie,
                detail: `![](${(item?.seriya?.afishaMin) ? encodeURI(ycStorage(auth) + ycBucket(auth) + "/" + item?.seriya?.afishaMin) : fallback})`,
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.seriya?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Серия, сезон ${item?.seriya?.sezon?.nazvanie}, ${item?.seriya?.urovenSerii?.nazvanie}`,
                image: (item?.seriya?.afishaMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.seriya?.afishaMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.kollektivID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.kollektiv?.nazvanieKollektiva,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.kollektiv?.nazvanieKollektiva + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Коллектив, ${item?.kollektiv?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.kollektiv?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.organizator?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.organizatorID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.organizator?.nazvanie,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.organizator?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Организатор, ${item?.organizator?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.organizator?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.organizator?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.paraID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.para?.para?.partner?.firstname + " " + item?.para?.para?.partner?.lastname + " - " +
                    item?.para?.para?.partnersha?.firstname + " " + item?.para?.para?.partnersha?.lastname,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.para?.para?.partner?.firstname + " " + item?.para?.para?.partner?.lastname + " - " +
                        item?.para?.para?.partnersha?.firstname + " " + item?.para?.para?.partnersha?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Пара, ${item?.para?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.para?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.para?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.prepodavatelID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.prepodavatel?.user?.firstname + " " + item?.prepodavatel?.user?.lastname,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.prepodavatel?.user?.firstname + " " + item?.prepodavatel?.user?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Преподаватель, ${item?.prepodavatel?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.prepodavatel?.user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.prepodavatel?.user?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.regionalnoeOtdelenieID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.regionalnoeOtdelenie?.nazvanie,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.regionalnoeOtdelenie?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Региональное отделение`,
                image: (item?.regionalnoeOtdelenie?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.organizator?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.shkolaID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.shkola?.nazvanieShkoliTantsev,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.shkola?.nazvanieShkoliTantsev + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Школа, ${item?.shkola?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.shkola?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.shkola?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.sudyaID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.sudya?.user?.firstname + " " + item?.sudya?.user?.lastname,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.sudya?.user?.firstname + " " + item?.sudya?.user?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Судья, ${item?.sudya?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.sudya?.user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.sudya?.user?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.tantsorID) {
            return {
                rowHeight: 36,
                key: item.ID || uuid(),
                name: item?.tantsor?.user?.firstname + " " + item?.tantsor?.user?.lastname,
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor(item?.tantsor?.user?.firstname + " " + item?.tantsor?.user?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Танцор, ${item?.tantsor?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.tantsor?.user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.tantsor?.user?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else {
            return {
                key: uuid(),
                name: "Неопознанный объект",
                detail: "",
                action: (i, { insertAtCursor, start, end, trigger }) => { },
                icon: <i className="fa fa-question-circle-o" style={{ fontSize: "9px", color: "grey" }}></i>,
                render: (item, idx) => <Item
                    key={item.key}
                    name={item.name}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        }
    }
    const _search = (resolve, token) => GETWITH(auth, "/api/search", [
        QueryParam("q", token),
        QueryParam("count", 10),
    ], ({ data }) => {
        let collection = [];
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            collection.push(SearchItem(item));
        }
        return resolve(collection)
    }, errorCatch);
    const throttleSearch = React.useCallback(_.throttle(_search, 2000, { leading: false, trailing: true }), []);
    const _vlozheniya = useCallback((auth, item, value, onChange, onAfterChange) => {

        const remove = (e) => {
            Modal.confirm({
                title: `Вы уверены что хотите удалить файл из рассылки?`,
                icon: <ExclamationCircleOutlined />,
                content: <span>{e?.file?.name}</span>,
                okText: "Да",
                okType: 'danger',
                cancelText: "Нет",
                onOk: () => {
                    GET(auth, `/api/rassilka/deletevlozhenie/${e.ID}`, ({ data }) => {
                        onChange(value.filter(o => o.ID !== e.ID))
                    }, errorCatch);
                },
            });
        }

        if (value && _.isArray(value)) {
            return <div>
                {JSXMap(value, (e, idx) => (<div key={e.ID} className='bg bg-grey bg-grey-hover' style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ flex: "1 1 auto", textAlign: "left", padding: "0 8px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{e?.file?.name}</div>
                    <div className='pointer' style={{ flex: "0 0 30px" }} onClick={() => remove(e)}><Icofont icon="close" /></div>
                </div>))}
            </div>
        }
        if (value && !_.isArray(value)) {
            return (<div style={{ paddingLeft: "2px", paddingTop: "5px", display: "flex", gap: "5px", fontSize: "12px" }}>
                <div style={{ flex: "0 0 30px", alignSelf: "start", fontSize: "10px", minHeight: "19px", color: "red" }} className={`bg bg-red dark-5`}>
                    Error
                </div>
                <div style={{ flex: "1 1 auto" }}>
                    <div>Неправильный тип элемента</div>
                </div>
            </div>)
        }
    }, [auth])

    const _apeendfiles = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<UploadFiles object={object} fileErrors={object?.fileErrors} auth={auth} item={item} value={value} onChange={onChange} onAfterChange={onAfterChange} />)
        // const remove = (e) => {
        //     Modal.confirm({
        //         title: `Вы уверены что хотите удалить файл из рассылки?`,
        //         icon: <ExclamationCircleOutlined />,
        //         content: <span>{e?.file?.name}</span>,
        //         okText: "Да",
        //         okType: 'danger',
        //         cancelText: "Нет",
        //         onOk: () => {
        //             GET(auth, `/api/rassilka/deletevlozhenie/${e.ID}`, ({ data }) => {
        //                 onChange(value.filter(o => o.ID !== e.ID))
        //             }, errorCatch);
        //         },
        //     });
        // }

        // if (value && _.isArray(value)) {
        //     return <div>
        //         {JSXMap(value, (e, idx) => (<div key={e.ID} className='bg bg-grey bg-grey-hover' style={{ display: "flex", justifyContent: "space-between" }}>
        //             <div style={{ flex: "1 1 auto", textAlign: "left", padding: "0 8px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{e?.file?.name}</div>
        //             <div className='pointer' style={{ flex: "0 0 30px" }} onClick={() => remove(e)}><Icofont icon="close" /></div>
        //         </div>))}
        //     </div>
        // }
        // if (value && !_.isArray(value)) {
        //     return (<div style={{ paddingLeft: "2px", paddingTop: "5px", display: "flex", gap: "5px", fontSize: "12px" }}>
        //         <div style={{ flex: "0 0 30px", alignSelf: "start", fontSize: "10px", minHeight: "19px", color: "red" }} className={`bg bg-red dark-5`}>
        //             Error
        //         </div>
        //         <div style={{ flex: "1 1 auto" }}>
        //             <div>Неправильный тип элемента</div>
        //         </div>
        //     </div>)
        // }
    }, [auth, object])

    const [formaID, setFormaID] = useState(1);

    //-------------------------------------------
    const fn = (resolve, token, formaID) => GET(auth, `/api/rassilka/${temaName(formaID)}`, ({ data }) => {
        let filtered_collection = data.filter(f => f.name.toLowerCase().indexOf(token.slice(1).toLowerCase()) >= 0)
        let collection = filtered_collection.map(item => {
            return {
                key: item.ID || uuid(),
                name: item.name,
                detail: item.detail,
                action: (i, { insertAtCursor, start, end, trigger }) => {
                    insertAtCursor("#" + item.name, start, end)
                },
                icon: <i className="fa fa-hashtag" style={{ fontSize: "9px", color: "black" }}></i>,
                render: (item, idx) => <Item key={item.key} name={item.name} icon={item.icon} style={{ fontSize: "13px" }} />
            }
        });
        return resolve(collection)
    }, errorCatch);
    const throttleFn = React.useCallback(_.throttle(fn, 2000, { leading: false, trailing: true }), []);
    const _autocomplite = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<Autocomplete
            auth={auth}
            item={item}
            value={value}
            onChange={onChange}
            onAfterChange={onAfterChange}
            virtualized={true}
            triggers={{
                "@.*": {
                    dataProvider: token => new Promise(resolve => throttleSearch(resolve, token)),
                },
                "#.*": {
                    dataProvider: token => new Promise(resolve => throttleFn(resolve, token, formaID)),
                },
                "\\$.*": {
                    dataProvider: token => {
                        return [
                            { name: "gender", text: "$gender(;)", detail: "#### Функция \n`$gender(;)` - эта функция будет заменена при отправке на первое заданное значение если пол получателя **Мужской** или на второе если пол получателя **Женский**\n\n\n**Пример:** \n\n`$gender(Уважаемый;Уважаемая)` будет заменено на **Уважаемый** для получателя мужского пола и на **Уважаемая** для получателя женского пола" },
                        ].filter(f => f.name.toLowerCase().indexOf(token.slice(1).toLowerCase()) >= 0).map(
                            ({ name, text, detail }) => ({
                                key: uuid(),
                                name,
                                icon: <i className="fa fa-usd" style={{ fontSize: "9px", color: "#1f3176" }}></i>,
                                detail: detail,
                                action: (item, { insertAtCursor, start, end, trigger }) => {
                                    insertAtCursor(text, start, end)
                                },
                                render: (item, idx) => <Item key={item.key} name={item.name} icon={item.icon} style={{ fontSize: "13px" }} />
                            }))
                    }
                },
                ":": {
                    dataProvider: token =>
                        emoji(token.slice(1))
                            .slice(0, 50)
                            .filter(({ char }) => char)
                            .map(({ name, char }) => ({
                                key: uuid(),
                                name,
                                detail: () => <div style={{ fontSize: "50px" }}>{char}</div>,
                                icon: char,
                                action: (item, { insertAtCursor, start, end, trigger }) => {
                                    insertAtCursor(char, end - trigger.length, end)
                                },
                                render: (item, idx) => <Item key={item.key} name={item.name} icon={item.icon} style={{ fontSize: "13px" }} />
                            })),
                }
            }}
        />)
    }, [auth, formaID])

    const JSXByMeta = (_meta) => {
        return _meta?.map((xitem, idx) => {
            if (!xitem.name && xitem.type === "func" && xitem.render) {
                return <div key={"func_" + idx}>
                    {xitem.render(auth, xitem)}
                </div>
            }
            return (<Form.Item
                preserve={(xitem.hidden) ? "true" : "false"}
                hidden={xitem.hidden}
                key={xitem.name}
                name={(xitem.type !== "object" && xitem.type !== "document") ? uncapitalize(xitem.name) : uncapitalize(xitem.name) + "ID"}
                label={(xitem.type !== "bool" && xitem.type !== "boolean") ? xitem.label : undefined}
                rules={formItemRules(xitem)}
            >
                <Field
                    mode="model"
                    key={xitem.name}
                    auth={auth}
                    formItem={true}
                    // filter={fieldsFilters[xitem.name.toLowerCase()]}
                    item={{ ...xitem, filterType: undefined, func: (funcStat && funcStat[xitem.name.toLowerCase()]) ? funcStat[xitem.name.toLowerCase()] : {} }}
                />
            </Form.Item>);
        })
    }

    const uiFilterDialogMeropriyatie = () => [
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "DESC",
            filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            filterType: "group",
            display: (o) => o.name,
            sort: true,
            filter: true
        },
    ]
    const displayStringDialogMeropriyatie = (item) => {
        return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
    }
    const displayDialogMeropriyatie = (item) => {
        return (
            <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                    <YImage item={item} width={32} hidePreview={true} />
                </div>

                <div style={{ flex: "auto", paddingLeft: "7px" }}>
                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                        {/* <a href={`/fed/event/${item.ID}`}> */}
                        <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                        {/* </a> */}
                    </div>
                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                        <span style={{
                            marginRight: "5px",
                            borderRadius: "5px",

                            // backgroundColor: "#f6214b",
                            // color: "white",

                            backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                            color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                            fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                            fontSize: "12px",


                            boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                            padding: "2px 4px"
                        }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                        <span>{item?.mestoProvedeniya?.name}</span>
                    </div>
                </div>
            </div>
        )
    }

    const _metaCreate = useMemo(() => [
        {
            label: "Группа рассылки",
            name: "gruppaPolzovatelei",
            type: "object",
            filterType: "group",
            inputProps: {mode: "multiple"},
            // type: "bigobject",
            relation: {
                display: (item) => {
                    return item.nazvanie
                },
                reference: { object: "GruppiPolzovateleiRassilok", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                QueryOrder("ID", "ASC")
            ]
        },
        {
            label: "Не отправлять тем кто в группе",
            name: "ignoreGruppa",
            type: "bool"
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            render: _autocomplite
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite, _apeendfiles])
    const _metaUpdate = useMemo(() => [
        {
            label: "Группа рассылки",
            name: "gruppaPolzovatelei",
            type: "object",
            filterType: "group",
            inputProps: {mode: "multiple"},
            // type: "bigobject",
            relation: {
                display: (item) => {
                    return item.nazvanie
                },
                reference: { object: "GruppiPolzovateleiRassilok", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                QueryOrder("ID", "ASC")
            ]
        },
        {
            label: "Не отправлять тем кто в группе",
            name: "ignoreGruppa",
            type: "bool"
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "common",
            render: _autocomplite
        },
        {
            label: "Файлы в рассылке",
            name: "vlozheniyaRassilki",
            type: "func",
            render: _vlozheniya
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite, _vlozheniya, _apeendfiles])
    const _metaMyresultCreate = useMemo(() => [
        {
            validators: { required: true },
            label: "Мероприятие",
            name: "event",
            type: "object",
            mode: "dialog",
            modal: { width: "700px" },
            relation: {
                uiFilter: uiFilterDialogMeropriyatie,
                display: displayDialogMeropriyatie,
                displayString: displayStringDialogMeropriyatie,
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
            queryFilter: [
                QueryParam("w-eq-isPublic", "true"),
                QueryDetail("model"),
                QueryOrder("nachaloSorevnovaniya", "DESC")
            ]
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "myresult",
            render: _autocomplite
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite])
    const _metaMyresultUpdate = useMemo(() => [
        {
            validators: { required: true },
            label: "Мероприятие",
            name: "event",
            type: "object",
            mode: "dialog",
            modal: { width: "700px" },
            relation: {
                uiFilter: uiFilterDialogMeropriyatie,
                display: displayDialogMeropriyatie,
                displayString: displayStringDialogMeropriyatie,
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
            queryFilter: [
                QueryParam("w-eq-isPublic", "true"),
                QueryDetail("model"),
                QueryOrder("nachaloSorevnovaniya", "DESC")
            ]
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "myresult",
            render: _autocomplite
        },
        {
            label: "Файлы в рассылке",
            name: "vlozheniyaRassilki",
            type: "func",
            render: _vlozheniya
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite, _vlozheniya, _apeendfiles])
    const _metaRezultatiFinalCreate = useMemo(() => [
        {
            validators: { required: true },
            label: "Мероприятие",
            name: "event",
            type: "object",
            mode: "dialog",
            modal: { width: "700px" },
            relation: {
                uiFilter: uiFilterDialogMeropriyatie,
                display: displayDialogMeropriyatie,
                displayString: displayStringDialogMeropriyatie,
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
            queryFilter: [
                QueryParam("w-eq-isPublic", "true"),
                QueryDetail("model"),
                QueryOrder("nachaloSorevnovaniya", "DESC")
            ]
        },
        {
            label: "Группа рассылки",
            name: "gruppaPolzovatelei",
            type: "object",
            filterType: "group",
            inputProps: {mode: "multiple"},
            // type: "bigobject",
            relation: {
                display: (item) => {
                    return item.nazvanie
                },
                reference: { object: "GruppiPolzovateleiRassilok", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                QueryOrder("ID", "ASC")
            ]
        },
        {
            label: "Не отправлять тем кто в группе",
            name: "ignoreGruppa",
            type: "bool"
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "myresult",
            render: _autocomplite
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite])
    const _metaRezultatiFinalUpdate = useMemo(() => [
        {
            validators: { required: true },
            label: "Мероприятие",
            name: "event",
            type: "object",
            mode: "dialog",
            modal: { width: "700px" },
            relation: {
                uiFilter: uiFilterDialogMeropriyatie,
                display: displayDialogMeropriyatie,
                displayString: displayStringDialogMeropriyatie,
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
            queryFilter: [
                QueryParam("w-eq-isPublic", "true"),
                QueryDetail("model"),
                QueryOrder("nachaloSorevnovaniya", "DESC")
            ]
        },
        {
            label: "Группа рассылки",
            name: "gruppaPolzovatelei",
            type: "object",
            filterType: "group",
            inputProps: {mode: "multiple"},
            // type: "bigobject",
            relation: {
                display: (item) => {
                    return item.nazvanie
                },
                reference: { object: "GruppiPolzovateleiRassilok", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                QueryOrder("ID", "ASC")
            ]
        },
        {
            label: "Не отправлять тем кто в группе",
            name: "ignoreGruppa",
            type: "bool"
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "myresult",
            render: _autocomplite
        },
        {
            label: "Файлы в рассылке",
            name: "vlozheniyaRassilki",
            type: "func",
            render: _vlozheniya
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite, _vlozheniya, _apeendfiles])
    const _metaPromokodiMeropriyatiyaCreate = useMemo(() => [
        {
            validators: { required: true },
            label: "Мероприятие",
            name: "event",
            type: "object",
            mode: "dialog",
            modal: { width: "700px" },
            relation: {
                uiFilter: uiFilterDialogMeropriyatie,
                display: displayDialogMeropriyatie,
                displayString: displayStringDialogMeropriyatie,
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
            queryFilter: [
                QueryParam("w-eq-isPublic", "true"),
                QueryDetail("model"),
                QueryOrder("nachaloSorevnovaniya", "DESC")
            ]
        },
        {
            label: "Отправить школам федерации",
            name: "checkShkoliFederatsii",
            type: "bool"
        },
        {
            label: "Отправить преподавателям федерации",
            name: "checkPrepodavateliFederatsii",
            type: "bool"
        },
        {
            label: "Отправить организаторам федерации",
            name: "checkOrganizatoriFederatsii",
            type: "bool"
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "promokodi-meropriyatiya",
            render: _autocomplite
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite])
    const _metaPromokodiMeropriyatiyaUpdate = useMemo(() => [
        {
            validators: { required: true },
            label: "Мероприятие",
            name: "event",
            type: "object",
            mode: "dialog",
            modal: { width: "700px" },
            relation: {
                uiFilter: uiFilterDialogMeropriyatie,
                display: displayDialogMeropriyatie,
                displayString: displayStringDialogMeropriyatie,
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
            queryFilter: [
                QueryParam("w-eq-isPublic", "true"),
                QueryDetail("model"),
                QueryOrder("nachaloSorevnovaniya", "DESC")
            ]
        },
        {
            label: "Отправить школам федерации",
            name: "checkShkoliFederatsii",
            type: "bool"
        },
        {
            label: "Отправить преподавателям федерации",
            name: "checkPrepodavateliFederatsii",
            type: "bool"
        },
        {
            label: "Отправить организаторам федерации",
            name: "checkOrganizatoriFederatsii",
            type: "bool"
        },
        {
            label: "Текст рассылки",
            name: "tekst",
            type: "func",
            tema: "promokodi-meropriyatiya",
            render: _autocomplite
        },
        {
            label: "Файлы в рассылке",
            name: "vlozheniyaRassilki",
            type: "func",
            render: _vlozheniya
        },
        {
            label: "Добавляемые файлы",
            name: "file",
            // type: "files",
            // accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
            type: "func",
            render: _apeendfiles
        }
    ], [_autocomplite, _vlozheniya, _apeendfiles])
    //-------------------------------------------

    // const tema = Form.useWatch('temaID', { form, preserve: true });
    const getObektiRassilki = (obj) => {
        let o = {}
        for (let i = 0; i < obj?.obektiRassilki?.length; i++) {
            const element = obj.obektiRassilki[i];
            if (element.ownerType === "meropriyatiya") {
                o["eventID"] = element.ownerID
            } else if (element.ownerType === "gruppi_polzovatelei_rassilok") {
                // o["gruppaPolzovateleiID"] = element.ownerID
                if (!o["gruppaPolzovateleiID"]) {
                    o["gruppaPolzovateleiID"] = []
                } 
                o["gruppaPolzovateleiID"].push(element.ownerID)
            }

            if (element.name === "checkPrepodavateliFederatsii") {
                o["checkPrepodavateliFederatsii"] = element.paramBool
            } else if (element.name === "checkShkoliFederatsii") {
                o["checkShkoliFederatsii"] = element.paramBool
            } else if (element.name === "checkOrganizatoriFederatsii") {
                o["checkOrganizatoriFederatsii"] = element.paramBool
            }
        }
        return o;
    }

    useEffect(() => {
        if (object?.tema?.formaID) {
            setFormaID(object?.tema?.formaID);
            form.setFieldsValue({
                ...object,
                ...getObektiRassilki(object)
            });
        }
    }, [object])

    return (
        <>
            <Form
                form={form}
                onFinish={(v) => props.submit({ ...v, formaID })}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                }}
                {...options}
            >
                <Form.Item
                    key={"tema"}
                    name={"temaID"}
                    label={"Рассылка"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите тему рассылки!' }]}
                >
                    <Field
                        mode="model"
                        key={"tema"}
                        auth={auth}
                        formItem={true}
                        // filter={fieldsFilters[xitem.name.toLowerCase()]}
                        item={{
                            ...{
                                view: { disabled: object && object.ID /*true*/ },
                                label: "Рассылка",
                                name: "tema",
                                type: "object",
                                relation: {
                                    display: (item) => {
                                        return item.nazvanie
                                    },
                                    reference: { object: "Rassilki", property: "ID", source: "/api/rassilki/list" },
                                    type: "many-one",
                                },
                                queryFilter: [
                                    QueryDetail("model"),
                                    QueryOrder("id", "ASC")
                                ]
                            },
                            filterType: undefined,
                            func: (funcStat && funcStat["tema"]) ? funcStat["tema"] : {}
                        }}
                        onChange={(value, item, obj) => setFormaID(obj?.formaID)}
                    />
                </Form.Item>

                {formaID === 1 && <>
                    {!(object && object.ID) && JSXByMeta(_metaCreate)}
                    {(object && object.ID) && JSXByMeta(_metaUpdate)}
                </>}
                {formaID === 2 && <>
                    {!(object && object.ID) && JSXByMeta(_metaMyresultCreate)}
                    {(object && object.ID) && JSXByMeta(_metaMyresultUpdate)}
                </>}
                {formaID === 3 && <>
                    {!(object && object.ID) && JSXByMeta(_metaRezultatiFinalCreate)}
                    {(object && object.ID) && JSXByMeta(_metaRezultatiFinalUpdate)}
                </>}
                {formaID === 4 && <>
                    {!(object && object.ID) && JSXByMeta(_metaPromokodiMeropriyatiyaCreate)}
                    {(object && object.ID) && JSXByMeta(_metaPromokodiMeropriyatiyaUpdate)}
                </>}

            </Form>
        </>
    );
}
